<template>
  <div>
    <div
      class="point-dialog"
      :style="{
        opacity: pointvisible ? 1 : 0,
        'z-index': pointvisible ? 4001 : -1,
      }"
    >
      <div class="title">{{ selectitem.value4 }}</div>
      <div class="log-content">{{ selectitem.value5 }}</div>
      <div class="dialog-close" @click="closedialog"></div>
    </div>
    <div class="map-mask-bg"></div>
    <div id="mapDiv" class="mapDiv"></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.mapbg",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      map: null,
      markerlist: [],
      CarTrack: {},
      geocode: null,
      address: "",
      beginadress: "",
      endadress: "",
      pointvisible: false,
      defaultdata: [
        {
          value1: "上海外滩茂悦大酒店",
          value2: "121.4885",
          value3: "31.2475",
          value4: "上海外滩茂悦大酒店",
          value5: "示例点位1",
          value6: "是"
        },
        {
          value1: "测试点2",
          value2: "111",
          value3: "25",
          value4: "测试点2",
          value5: "测试点2内容",
        },
        {
          value1: "测试点3",
          value2: "94",
          value3: "34",
          value4: "测试点3",
          value5: "测试点3内容",
        },
        {
          value1: "测试点4",
          value2: "86",
          value3: "40",
          value4: "测试点4",
          value5: "测试点4内容",
        },
        {
          value1: "测试点5",
          value2: "108",
          value3: "40",
          value4: "测试点5",
          value5: "测试点5内容",
        },
        {
          value1: "测试点6",
          value2: "124",
          value3: "45",
          value4: "测试点6",
          value5: "测试点6内容",
        },
      ],
      valueMap: [
        { name: "点位名称", key: "value1" },
        { name: "经度", key: "value2" },
        { name: "纬度", key: "value3" },
        { name: "弹窗标题", key: "value4" },
        { name: "弹窗内容", key: "value5" },
        { name: "是否默认中心点", key: 'value6' }
      ],
      apiconfig: {},
      isApi: false,
      exceldata: [],
      selectitem: "",
      scope: {},
      carlist: []
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
        this.uploadMaker();
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  mounted() {
    this.setData()
    this.mapstart();
  },
  methods: {
    ...methods,
    mapstart() {
      var map;
      var zoom = 13;
      var lay;
      var onlyMapLay;
      var config;
      var imageURL;
      var icon;
      var marker;
      var infoWin1;
      var sContent;
      var lng;
      var lat;
      var latlng;
      var label;
      var line;
      var localsearch;
      var countries1 = [];
      var countriesOverlay2 = new T.D3Overlay(init2, redraw2);
      const _this = this;
      this.map = new T.Map("mapDiv");
      this.map.centerAndZoom(new T.LngLat(105, 38), 5);
      //初始化地图对象
      // this.map.setStyle("indigo");
      // this.map.setStyle("black");
      var myfilter = "hue-rotate(180deg) invert(86%) saturate(80%) brightness(137%)"
      //设置主题色
      let example = document.getElementById("mapDiv")
      example.style.filter = myfilter;
      d3.json("https://shop.17886.cn/100000.json", function (data) {
        countries1 = data.features;
        _this.map.addOverLay(countriesOverlay2);
      });
      const pointicon = require("@/assets/template/point.png");
      this.defaultdata.forEach((item) => {
        let car_icon = new T.Icon({
          iconUrl: pointicon,
          iconSize: new T.Point(40, 48),
          iconAnchor: new T.Point(20, 24),
        });
        // 向地图上添加自定义标注
        let car_marker = new T.Marker(new T.LngLat(item.value2, item.value3), {
          icon: car_icon,
          title: item.value1,
        });
        car_marker.addEventListener("click", () => {
          _this.addmaker(item);
        });
        _this.map.addOverLay(car_marker);
        this.carlist.push(car_marker)
      });
      function init2(sel, transform) {
        var upd1 = sel.selectAll("path.geojson1").data(countries1);
        upd1
          .enter()
          .append("path")
          .attr("class", "geojson1")
          .attr("stroke", "#1a96ff")
          .attr("fill", function (d, i) {
            return d3.rgb(41, 97, 221);
          })
          .attr("fill-opacity", ".01")
          .attr("stroke-opacity", "1")
          .attr("stroke-width", "3px");
      }
      function redraw2(sel, transform) {
        sel.selectAll("path.geojson1").each(function (d, i) {
          d3.select(this).attr("d", transform.pathFromGeojson);
        });
      }
      let centerPoint = this.defaultdata.find(item => item.value6 == '是')
      if (centerPoint) {
        setTimeout(() => {
          this.map.centerAndZoom(new T.LngLat(centerPoint.value2, centerPoint.value3), 5);
        }, 2000);
        setTimeout(() => {
          this.map.centerAndZoom(new T.LngLat(centerPoint.value2, centerPoint.value3), 16);
        }, 2800);
      }
    },
    addmaker(e) {
      console.log("addmaker", e);
      this.selectitem = e;
      this.pointvisible = true;
    },
    closedialog() {
      this.pointvisible = false;
    },
    uploadMaker() {
      const _this = this;
      this.carlist.forEach(item => {
        this.map.removeOverLay(item)
      })
      this.carlist = []
      const pointicon = require("@/assets/template/point.png");
      this.defaultdata.forEach((item) => {
        let car_icon = new T.Icon({
          iconUrl: pointicon,
          iconSize: new T.Point(40, 48),
          iconAnchor: new T.Point(20, 24),
        });
        // 向地图上添加自定义标注
        let car_marker = new T.Marker(new T.LngLat(item.value2, item.value3), {
          icon: car_icon,
          title: item.value1,
        });
        car_marker.addEventListener("click", () => {
          _this.addmaker(item);
        });
        this.map.addOverLay(car_marker);
        this.carlist.push(car_marker)
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mapDiv {
  width: 1920px;
  height: 1080px;
  position: absolute;
}
.ys-dialog {
  width: 455px;
  height: 219px;
  background-size: 100% 100%;
  position: absolute;
  bottom: 54px;
  left: calc(50% - 227.5px);
  z-index: 401;
}
.car-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 15px;
  color: #f9fbff;
  line-height: 15px;
  margin: 8px 0 0 90px;
}
.title1 {
  margin-top: 38px;
  margin-left: 50px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a3b1b9;
  line-height: 26px;
  max-width: 378px;
  & + .title1 {
    margin-top: 8px;
  }
  em {
    color: #01a8ff;
  }
}
.point-dialog {
  position: absolute;
  width: 360px;
  height: 192px;
  left: calc(50% - 100px);
  top: calc(50% - 100px);
  pointer-events: auto;
  opacity: 0;
  transition: all 0.5s linear;
  background: url(../../assets/template/temlog.png) no-repeat;
  background-size: 100% 100%;
  .title {
    margin: 16px 0 0 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    line-height: 34px;
    text-shadow: 0px 2px 2px rgba(2, 17, 20, 0.15);
    font-style: italic;
    background: linear-gradient(to bottom, #fff, #d8dff4, #6384d6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .log-content {
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #b2c1e7;
    margin: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 24px;
  }
}
.dialog-close {
  position: absolute;
  right: 22px;
  top: 22px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.map-mask-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 400;
  pointer-events: none;
  background: rgba(26, 150, 255, 0.2);
  top: 0;
  left: 0;
  mix-blend-mode: color;
}
</style>
